import { Mail, FileText, Users, Database, MessageSquare, Search } from "lucide-react";
export const AiAgentsUseCases = () => {
  const cases = [
    { icon: Mail, title: "Email Processing", desc: "Categorize, respond, and route emails automatically", color: "text-primary" },
    { icon: FileText, title: "Document Analysis", desc: "Extract data from invoices, contracts, reports", color: "text-chart-2" },
    { icon: Users, title: "Lead Qualification", desc: "Score and route leads based on criteria", color: "text-chart-4" },
    { icon: Database, title: "Data Entry", desc: "Move data between systems automatically", color: "text-chart-1" },
    { icon: MessageSquare, title: "Customer Support", desc: "Answer FAQs and escalate complex issues", color: "text-chart-3" },
    { icon: Search, title: "Research", desc: "Gather and summarize information from sources", color: "text-destructive" },
  ];
  return (
    <section className="py-8 sm:py-12">
      <h2 className="text-2xl sm:text-3xl font-display font-bold text-foreground mb-6">Common Use Cases</h2>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {cases.map((c, i) => (
          <div key={i} className="bg-card rounded-xl border border-border p-5">
            <c.icon className={`w-8 h-8 ${c.color} mb-3`} />
            <h3 className="font-semibold text-foreground mb-1">{c.title}</h3>
            <p className="text-sm text-muted-foreground">{c.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};
